import "./App.css";
import styled from "@emotion/styled";
import { observer } from "mobx-react";
import { appStore } from "./common/store/AppStore";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect, Suspense, lazy } from "react";
import { devToolsDetector } from "./common/utils/DetectDebug";

const Report = lazy(() => import("./modules/report/components"));
const Report1 = lazy(() => import("./modules/report1/components"));

const App = () => {
  useEffect(() => {
    devToolsDetector.initialize();
    return () => {
      devToolsDetector.cleanup();
    };
  }, []);

  return (
    <Router>
      <Body style={{ background: appStore.isLightMode ? "#F3F5F9" : "" }}>
        <Content>
          <ColLeft>
            <Suspense
              fallback={
                <div style={{ color: "white", padding: 20 }}>
                  Đang tải dữ liệu xin chờ trong giây lát...
                </div>
              }
            >
              <Routes>
                <Route path="/" element={<Report1 />} />
                <Route path="/report" element={<Report />} />
                <Route path="/report-1" element={<Report1 />} />
              </Routes>
            </Suspense>
          </ColLeft>
        </Content>
      </Body>
    </Router>
  );
};

export default observer(App);

const Body = styled.div`
  background-color: #13161b;
  width: 100%;
  height: 100%;
  position: fixed;
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;
const ColLeft = styled.div`
  width: 100%;
`;
